import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export class PM2Service {
  /**
   * Busca métricas brutas do PM2
   */
  static async getMetrics() {
    try {
      const token = localStorage.getItem('token');
      console.log('DEBUG [PM2Service.getMetrics]:', { token: token ? '***' : 'null' });
      
      const response = await axios.get(`${API_BASE_URL}/metrics/pm2`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar métricas PM2:', error);
      throw error;
    }
  }

  /**
   * Busca métricas formatadas do PM2
   */
  static async getFormattedMetrics() {
    try {
      const token = localStorage.getItem('token');
      console.log('DEBUG [PM2Service.getFormattedMetrics]:', { 
        token: token ? '***' : 'null',
        tokenLength: token?.length || 0,
        hasBearer: token ? 'yes' : 'no'
      });
      
      const response = await axios.get(`${API_BASE_URL}/metrics/pm2/formatted`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar métricas formatadas PM2:', error);
      throw error;
    }
  }
}

export default PM2Service;
